import reactorUrl from "../fonts/RST Reactor VF Regular.woff2";
import newsreaderUrl from "../fonts/Newsreader.woff2";
import robotoMonoUrl from "../fonts/RobotoMono.woff2";

// Injected as early as possible (first import in src/index.js) so the fetch
// for these above-the-fold fonts starts before the rest of the bundle even
// evaluates. Each URL is the same webpack-hashed asset src/index.css's
// @font-face rules resolve to, so the browser matches this preload to the
// actual font request instead of fetching it twice.
[reactorUrl, newsreaderUrl, robotoMonoUrl].forEach((href) => {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "font";
  link.type = "font/woff2";
  link.crossOrigin = "anonymous";
  link.href = href;
  document.head.appendChild(link);
});
